import { Section, type SectionProps } from "components/section";
import React from "react";
import { TextTitle, type TextTitleProps } from "ui/text";
import { AidDemoVideo } from "./aid-demo-video";

type AidDemoVideoSectionProps = SectionProps &
  Pick<TextTitleProps, "title" | "description"> & {
    textMaxW?: TextTitleProps["maxW"];
  };

export function AidDemoVideoSection({ title, description, textMaxW, ...props }: AidDemoVideoSectionProps) {
  return (
    <Section {...props}>
      <TextTitle size="lg" align="center" title={title} description={description} maxW={textMaxW} />
      <AidDemoVideo />
    </Section>
  );
}
